<template>
  <div class="create-job-profile-step2 d-flex flex-column h-100">
    <div class="step-header pa-6 pb-4">
      <div class="d-flex align-center ga-3">
        <div>
          <div class="text-h6 text-textDarkest">
            Choose a Template
          </div>
          <div class="text-body-2 text-textLight mt-1">
            Select an optional template to pre-fill your new profile's content.
          </div>
        </div>
      </div>
    </div>

    <v-divider class="opacity-100" />

    <div class="step-body flex-grow-1 overflow-hidden">
      <v-row
        no-gutters
        class="h-100"
      >
        <v-col
          cols="5"
          class="border-e d-flex flex-column h-100"
        >
          <div
            v-if="store.templatesLoading"
            class="d-flex justify-center pa-6"
          >
            <v-progress-circular
              indeterminate
              color="brandPrimary"
              size="32"
              width="2"
            />
          </div>

          <div
            v-else-if="store.templates.length === 0"
            class="text-body-2 text-textLight text-center pa-6"
          >
            No templates available. You can still create a blank profile.
          </div>

          <v-list
            v-else
            density="compact"
            class="pa-2 overflow-y-auto flex-grow-1"
          >
            <v-list-item
              :active="store.selectedTemplateUlid === null"
              color="brandPrimary"
              rounded="lg"
              @click="clearTemplate"
            >
              <v-list-item-title class="text-body-2 text-textDarkest font-weight-medium">
                No template
              </v-list-item-title>
              <v-list-item-subtitle class="text-caption text-textLight">
                Start with a blank profile
              </v-list-item-subtitle>
            </v-list-item>

            <v-divider class="my-2 opacity-100" />

            <v-list-item
              v-for="template in store.templates"
              :key="template.ulid"
              :active="store.selectedTemplateUlid === template.ulid"
              color="brandPrimary"
              rounded="lg"
              @click="store.selectTemplate(template.ulid)"
            >
              <v-list-item-title class="text-body-2 text-textDarkest">
                {{ template.title }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-col>

        <v-col
          cols="7"
          class="overflow-y-auto h-100"
        >
          <WizardProfilePreview
            :profile="store.mergedProfileAndTemplatePreview ? {
              ...store.mergedProfileAndTemplatePreview,
              title: formTitle,
              job_code: formJobCode,
              location: formLocation,
              is_hris_profile: false,
            } : null"
            :loading="store.templatePreviewLoading"
          >
            <template #empty>
              Select a template on the left to preview its content here.
            </template>
          </WizardProfilePreview>
        </v-col>
      </v-row>
    </div>

    <v-divider class="opacity-100" />

    <div class="step-footer pa-6 d-flex ga-4">
      <v-btn
        class="h-100"
        variant="text"
        color="textDarkest"
        density="compact"
        prepend-icon="$arrow-left"
        @click="store.goToStep1"
      >
        Back
      </v-btn>

      <v-btn
        color="primary"
        variant="flat"
        rounded="lg"
        :loading="store.createLoading"
        @click="store.createProfile(router)"
      >
        Create Profile
      </v-btn>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useCreateJobProfileWizard } from '@/stores/jobProfiles/createJobProfileWizard';
import { storeToRefs } from 'pinia';
import WizardProfilePreview from './WizardProfilePreview.vue';

const store = useCreateJobProfileWizard();
const router = useRouter();
const { formTitle, formJobCode, formLocation } = storeToRefs(store);

const clearTemplate = () => {
  store.selectedTemplateUlid = null;
  store.templatePreview = null;
};

onMounted(() => {
  store.loadTemplates();
});
</script>
